import React, { useEffect } from "react";
import { XMarkIcon } from "@heroicons/react/24/solid";

const VideoModal = ({ videoUrl = "", isOpen, onClose }) => {
  // Close modal on ESC key
  useEffect(() => {
    const handleKeyDown = (event) => {
      if (event.key === "Escape") {
        onClose();
      }
    };
    if (isOpen) {
      document.addEventListener("keydown", handleKeyDown);
    }
    return () => {
      document.removeEventListener("keydown", handleKeyDown);
    };
  }, [isOpen, onClose]);

  if (!isOpen || !videoUrl) return null; // Prevent rendering if there's no video URL

  // Ensure videoUrl is a valid string before using endsWith
  const isMp4 = typeof videoUrl === "string" && videoUrl.endsWith(".mp4");

  return (
    <div
      className="fixed inset-0 bg-black bg-opacity-70 flex items-center justify-center z-50"
      onClick={onClose}
    >
      <div
        className="bg-white rounded-lg shadow-lg w-full max-w-3xl p-6 relative"
        onClick={(e) => e.stopPropagation()} // Prevent closing when clicking inside modal
      >
        {/* Close Button */}
        <button
          onClick={onClose}
          className="absolute top-3 right-3 text-gray-600 hover:text-black"
        >
          <XMarkIcon className="w-8 h-8" />
        </button>

        {/* Video Content */}
        <div className="w-full max-w-3xl">
          {isMp4 ? (
            <video
              className="w-full max-h-[500px] rounded-lg"
              src={videoUrl}
              controls
              autoPlay
              playsInline
            />
          ) : (
            <iframe
              className="w-full aspect-video max-h-[500px] rounded-lg"
              src={
                videoUrl.includes("youtube.com")
                  ? `https://www.youtube.com/embed/${new URL(
                      videoUrl
                    ).searchParams.get("v")}`
                  : videoUrl
              }
              title="Machine Demo"
              frameBorder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowFullScreen
            ></iframe>
          )}
        </div>
      </div>
    </div>
  );
};

export default VideoModal;
